import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../../Config/axiosInstance";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { DataGrid } from "@mui/x-data-grid";
import { NumericFormat } from "react-number-format"; // Adaugă această importare
import "./AddAutovehicles.css";
import "./AllAutovehicles.css";
import AddProblems from "./AddProblems";

const AutovehiclesProblems = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    //state principale
    const [vehicle, setVehicle] = useState(null);
    const [problems, setProblems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openAdd, setOpenAdd] = useState(false);
    
    // Starea pentru active tab
    const [activeTab, setActiveTab] = useState("problems");

    //permisiuni
    const [canView, setCanView] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canCreate, setCanCreate] = useState(false);

    //citire permisiuni
    useEffect(() => {
        const requiredPath = "/all-autovehicles";
        const storedPermissions = JSON.parse(localStorage.getItem("permissions"));
        const pages = storedPermissions?.pages ?? [];

        const checkPermission = (key) =>
            pages.some((p) => {
                try {
                    return new URL(p.url).pathname === requiredPath && p[key] === true;
                } catch {
                    return false;
                }
            });

        setCanView(checkPermission("can_view"));
        setCanEdit(checkPermission("can_edit"));
        setCanCreate(checkPermission("can_create"));
    }, []);

    //incarcare date vehicul+probleme
    const loadData = async () => {
        try {
            const resVehicle = await axiosInstance.get(`/all-autovehicles/${id}/`);
            setVehicle(resVehicle.data);

            const resProblems = await axiosInstance.get(`/autovehicles-problems/`);

            const filtered = resProblems.data
                .filter((p) => p.car_details === Number(id))
                .map((p) => ({ ...p, id: p.id }));

            setProblems(filtered);
        } catch (err) {
            console.error("Error loading data", err);
        }
        setLoading(false);
    };

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

 
    //refresh lista probleme dupa save
    const refreshProblems = async () => {
        const res = await axiosInstance.get(`/autovehicles-problems/`);
        const filtered = res.data
            .filter((p) => p.car_details === Number(id))
            .map((p) => ({ ...p, id: p.id }));

        setProblems(filtered);
    };

    //status
    const handleStatusToggle = async (problem) => {
        if (!canEdit) return;

        try {
            await axiosInstance.put(`/autovehicles-problems/${problem.id}/`, {
                problem: problem.problem,
                value: problem.value,
                status: !problem.status,
                car_details: problem.car_details,
            });

            refreshProblems();
        } catch (err) {
            console.error("Error updating status", err);
            alert("Error updating status");
        }
    };

    //definire coloane tabel
    const columns = useMemo(
        () => [
            {
                field: "problem",
                headerName: "Problem",
                flex: 1.5,
                minWidth: 150,
            },
            {
                field: "value",
                headerName: "Value (LEI)",
                flex: 0.8,
                minWidth: 120,
                renderCell: (params) => (
                    <NumericFormat
                        value={params.row.value || 0}
                        displayType="text"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        fixedDecimalScale
                        allowNegative={false}
                        style={{
                            fontFamily: "inherit",
                            fontSize: "inherit",
                            color: "inherit"
                        }}
                    />
                ),
            },
            {
                field: "status",
                headerName: "Status",
                flex: 0.7,
                minWidth: 110,
                sortable: false,
                renderCell: (params) => (
                    <input
                        type="checkbox"
                        checked={params.row.status}
                        disabled={!canEdit}
                        onChange={() => {
                            if (!canEdit) return;
                            handleStatusToggle(params.row);
                        }}
                        style={{
                            transform: "scale(1.2)",
                            cursor: canEdit ? "pointer" : "not-allowed",
                            opacity: canEdit ? 1 : 0.5
                        }}
                    />
                ),
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [canEdit]
    );

    // Funcție pentru navigarea între tab-uri - MODIFICAT: adăugat "mileagehistory"
    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (tab === "details") {
            navigate(`/all-autovehicles/view/${id}`);
        } else if (tab === "contract-information") {
            navigate(`/all-autovehicles/view/${id}/contract-information`);
        } else if (tab === "mileagehistory") {
            navigate(`/all-autovehicles/view/${id}/mileagehistory`);
        } else {
            // Dacă suntem deja pe problems, nu facem navigate
            if (window.location.pathname !== `/all-autovehicles/view/${id}/problems`) {
                navigate(`/all-autovehicles/view/${id}/problems`);
            }
        }
    };

    if (loading) return <div className="loading">Loading...</div>;

    if (!canView) {
        return (
            <div style={{ padding: "40px", textAlign: "center", fontSize: "18px" }}>
                ❌ You do not have permission to view this page.
            </div>
        );
    }

    return (
        <div className="addautovehicles-page">
            <div className="add-autovehicle-container">

                {/* HEADER */}
                <div className="top-header addauto-header">
                    <div className="header-left">
                        <ArrowBackIcon
                            className="back-icon-autovehicles"
                            onClick={() => navigate("/all-autovehicles")}
                        />
                        <h2 className="header-title-autovehicles">View autovehicle</h2>
                    </div>

                    <div className="header-actions">
                        {canCreate && (
                            <button
                                className="add-expense"
                                onClick={() => {
                                    if (!canCreate) return;
                                    setOpenAdd(true);
                                }}
                            >
                                + ADD EXPENSE
                            </button>
                        )}
                    </div>
                </div>

                <hr className="header-divider-autovehicles" />

                {/* TABS - MODIFICAT: Adăugat tab-ul "Mileage History" */}
                <div className="tab-buttons-autovehicles">
                    <button
                        className={`tab-btn ${activeTab === "details" ? "active" : ""}`}
                        onClick={() => handleTabClick("details")}
                    >
                        Details
                    </button>
                    <button
                        className={`tab-btn ${activeTab === "contract-information" ? "active" : ""}`}
                        onClick={() => handleTabClick("contract-information")}
                    >
                        Contract Information
                    </button>
                    <button
                        className={`tab-btn ${activeTab === "mileagehistory" ? "active" : ""}`}
                        onClick={() => handleTabClick("mileagehistory")}
                    >
                        Mileage History
                    </button>
                    <button
                        className={`tab-btn ${activeTab === "problems" ? "active" : ""}`}
                        onClick={() => handleTabClick("problems")}
                    >
                        Problems
                    </button>
                </div>

                {/* LAYOUT */}
                <div className="problems-layout">

                    {/* LEFT INFO */}
                    <div className="problems-info-card">
                        <div className="info-title">INFO AUTO</div>
                        <p><strong>Registration number: </strong>{vehicle?.registration_number}</p>
                        <p><strong>Auto: </strong>{vehicle?.auto}</p>
                        <p><strong>Auto type: </strong>{vehicle?.auto_type}</p>
                        <p><strong>VIN series: </strong>{vehicle?.VIN_series}</p>
                        <p><strong>Made year: </strong>{vehicle?.year?.split("-")[0]}</p>
                        <p><strong>Cylindrical capacity: </strong>{vehicle?.cylindrical_capacity} cm³</p>
                        <p><strong>Combustible: </strong>{vehicle?.combustibile}</p>
                    </div>

                    {/* TABLE */}
                    <div className="problems-table-card">
                        <h3>DECLARED PROBLEMS</h3>

                        <div className="table-container">
                            <DataGrid
                                rows={problems}
                                columns={columns}
                                disableRowSelectionOnClick
                                pageSizeOptions={[5, 10, 20]}
                                initialState={{
                                    pagination: {
                                        paginationModel: { pageSize: 10, page: 0 },
                                    },
                                }}
                                rowHeight={42}
                                sx={{
                                    borderRadius: "8px",
                                    background: "white",
                                    "& .MuiDataGrid-cell": {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                                        outline: "none",
                                    },
                                }}
                            />
                        </div>
                    </div>
                </div>

                {/* POPUP */}
                {openAdd && canCreate && (
                    <AddProblems
                        vehicleId={id}
                        onClose={() => setOpenAdd(false)}
                        onSaved={() => {
                            setOpenAdd(false);
                            refreshProblems();
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default AutovehiclesProblems;